export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";